export default "__VITE_ASSET__DPrt0ewz__"